<template>
  <v-dialog
    :value="value"
    persistent
    max-width="320"
  >
    <v-card light>
      <v-card-title v-text="title" />
      <v-card-subtitle v-text="subtitle" />
      <v-card-text>
        <v-text-field
          v-model="text"
          :label="label"
          outlined
          @keyup.enter="done()"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="grey darken-1"
          @click="cancel()"
          v-text="__('cancel')"
        />
        <v-spacer />
        <v-btn
          :disabled="disabled"
          color="primary"
          text
          @click="done()"
          v-text="__('done')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      I18n,
    ],

    props: {
      value: {
        required: true,
        type: Boolean,
      },
      title: {
        required: true,
        type: String,
      },
      subtitle: {
        required: false,
        type: String,
      },
      label: {
        required: false,
        type: String,
      },
    },

    data: () => ({
      text: '',
    }),

    computed: {
      disabled () {
        return this.text.length < 3
      },
    },

    methods: {
      close () {
        this.$emit('input', false)
        setTimeout(() => this.text = '', 75)
      },
      cancel () {
        this.close()
      },
      done () {
        this.$emit('submit', this.text)
        this.close()
      },
    },
  }
</script>
